import axiosInstance from '@fs/zion-axios'
import getProductHeader from '../common/getProductHeader'

let isActive = false

export function setSourceCentricDetailsActive(active: boolean): void {
  isActive = active
}

axiosInstance.interceptors.request.use((config) => {
  if (!isActive) return config

  // Don't attach Product to cross-origin requests — it isn't in their CORS Access-Control-Allow-Headers.
  // Same guard as @fs/zion-axios's built-in productHeaderInterceptor (see FRONTIER-4488).
  const url = config.url ?? ''
  const isCrossOrigin =
    url.startsWith('http') && typeof window !== 'undefined' && !url.startsWith(window.location.origin)
  if (isCrossOrigin) return config

  config.headers.product = getProductHeader({ featureOverride: 'tree:scperson' })

  return config
})
